import { Constants as TotalReturnsConstants } from '../total-returns/total-returns.constants';

export const Constants = {
  TAG_NAME: 'pop-total-returns-chart-component',
} as const;

export const CurrentYearPerformanceCategories = {
  MonthlyYTD: TotalReturnsConstants.MONTHLY_YTD,
  OneMonth: TotalReturnsConstants.ONE_MONTH,
  ThreeMonths: TotalReturnsConstants.THREE_MONTHS,
} as const;

export const CompositePerformanceCategories = {
  OneYear: TotalReturnsConstants.ONE_YEAR,
  ThreeYear: TotalReturnsConstants.THREE_YEAR,
  FiveYear: TotalReturnsConstants.FIVE_YEAR,
  TenYear: TotalReturnsConstants.TEN_YEAR,
  SinceInception: TotalReturnsConstants.SINCE_INCEPTION,
} as const;

export const DISCLAIMER_CODES = {
  TOTAL_RETURNS_DISCLAIMER_CODE: 'SMA-TotalRtrnNetAnnEqMA',
  TOTAL_RETURNS_FIXED_INCOME_DISCLAIMER_CODE: 'SMA-TotalRtrnNetAnnFI',
};

export const PerformanceTypes = {
  ...DISCLAIMER_CODES,
  PureGross: TotalReturnsConstants.PURE_GROSS,
  PureGrossFixedIncome: TotalReturnsConstants.PURE_GROSS_FIXED_INCOME,
  Net: TotalReturnsConstants.NET,
  NetFixedIncome: TotalReturnsConstants.NET_FIXED_INCOME,
  Benchmark: TotalReturnsConstants.BENCHMARK,
} as const;
